import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sentenceAllTagsResolver: FieldResolver = (metadata: Metadata) =>
  ({ sentenceAllTags: metadata.getSentenceAllTags() } as StreamData)

export default sentenceAllTagsResolver
